<template>
  <form v-on:submit.prevent="Submit" class="Content">
    <Modal
      v-if="Modal"
      :Titulo="Titulo"
      :Texto="Texto"
      :Color="Color"
      @Aceptar="Aceptar"
    />
    <h1>egep</h1>
    <h3>Consultores</h3>
    <span> Consulting Management System </span>
    <p data-v-step="0">LOGIN</p>
    <div class="input" data-v-step="1">
      <font-awesome-icon icon="user" class="icono" />
      <input type="email" placeholder=" Email" v-model="Email" required />
    </div>
    <div class="input" data-v-step="2">
      <font-awesome-icon icon="lock" class="icono" />
      <input
        type="password"
        name="Password"
        placeholder=" Password"
        v-model="Contrasena"
        required
      />
    </div>
    <button type="submit" data-v-step="4">LOGIN</button>
    <div class="forget">
      <router-link to="/RecoverPassword" data-v-step="3">
        Forgot your pasword?
      </router-link>
    </div>
    
  </form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Modal from "../../components/Modal.vue";
export default {
  data: () => ({
    Email: "",
    Contrasena: "",
    Modal: false,
    Titulo: "Error",
    Texto: "your email or password are wrong",
    Color: "background: red;",
    
  }),
  computed: {
    ...mapGetters("UserManager", ["getUserLoged"]),
  },
  methods: {
    ...mapActions("UserManager", ["Login"]),
    async Submit() {
      const credentials = {
        username: this.Email,
        password: this.Contrasena,
      };
      if (await this.Login(credentials)) {
        this.Modal = false;
        this.$router.push({ path: "/" });
      } else {
        this.Modal = true;
      }
    },
    Aceptar() {
      this.Modal = false;
    }
  },
  components: { Modal  },
};
</script>
<style lang="css" scoped>
.Content {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
.input {
  width: 100%;
  color: var(--second-color);
}
.Content input {
  width: 60%;
  margin: 1rem;
  height: 45px;
  border: none;
  background: var(--dark-firts-color);
  color: var(--second-color);
  border-radius: 15px;
  padding-left: 40px !important;
  padding: 5px;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  outline: none;
}
.Content input::-ms-reveal,
.Content input::-ms-clear {
  color: var(--second-color);
}
.Content input::placeholder {
  color: var(--second-color);
  font-family: Poppins, Regular;
}
.icono {
  position: absolute;
  pointer-events: none;
  color: var(--second-color);
  font-size: 1.5rem;
  margin: 25px;
  margin-left: 30px;
  --webkit-margin-left: 30px;
}
.Content p {
  margin-bottom: 20pt;
  font-size: 40pt;
  color: var(--eleventh-color);
  font-family: "Poppins", sans-serif;
  font-weight: 300;
}
.forget {
  text-decoration: none;
  color: var(--dark-third-color) !important;
  width: 55%;
  display: flex;
  justify-content: flex-end;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  margin-right: -30px;
}

.Content button {
  background: var(--firts-color);
  width: 60%;
  margin: 1rem;
  height: 2.7rem;
  border: none;
  border-radius: 15px;
  color: var(--second-color);
  font-size: 20px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  outline: none;
}
.Content h1 {
  font-family: "glacial-indifference", sans-serif;
  font-weight: 500;
  display: none;
}
.Content h3 {
  font-family: "glacial-indifference", sans-serif;
  font-weight: 500;
  display: none;
}
.Content span {
  font-family: "glacial-indifference", sans-serif;
  font-weight: 500;
  display: none;
}
.Content a {
  color: black;
}
@media (max-width: 1100px) {
  .Content p {
    font-size: 30pt;
  }
}
@media (max-width: 800px) {
  .Content {
    color: var(--second-color);
    justify-content: flex-end;
  }
  .Content p {
    display: none;
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
  .Content h1 {
    display: block;
    font-size: 100px;
    text-align: center;
    margin: 0;
    color: var(--sixth-color);
    margin-bottom: -20px;
  }
  .Content h3 {
    display: block;
    font-size: 45px;
    margin: 5px;
    text-align: center;
    color: var(--sixth-color);
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
  .Content a {
    color: var(--second-color);
    margin-bottom: 30px;
  }
  .Content span {
    display: block;
    margin: 10%;
    font-size: 20px;
    text-align: center;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    color: var(--sixth-color);
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
}
@media (max-width: 500px) {
  .Content input {
    width: 85%;
  }
  .Content button {
    width: 85%;
  }
  .forget {
    margin-right: -28%;
  }
}
</style>